import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81d60966"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btLine" }, null, -1))
const _hoisted_2 = { class: "btm" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Join Our Community", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]

import { MyImage } from '@icon/MyImage';


export default /*#__PURE__*/_defineComponent({
  __name: 'Bt',
  setup(__props) {

const clk = (url: string) => {
	window.open(url, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = () => clk('https://twitter.com/0xSingularLabs')),
        src: _unref(MyImage).home.twiter,
        class: "icon",
        alt: ""
      }, null, 8, _hoisted_4),
      _createElementVNode("img", {
        onClick: _cache[1] || (_cache[1] = () => clk('https://discord.com/invite/63n4MW4Y7a')),
        src: _unref(MyImage).home.tw1,
        class: "icon",
        alt: ""
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        onClick: _cache[2] || (_cache[2] = () => clk('https://medium.com/@singularlabs')),
        src: _unref(MyImage).home.tw2,
        class: "icon",
        alt: ""
      }, null, 8, _hoisted_6)
    ])
  ]))
}
}

})